import { useEffect, useRef, useState } from 'react';

/** Text to put in the question box for editing, such as a picked prompt. A new id applies it again. */
export type Prefill = { text: string; id: number };

/** The question box's text. A newly picked prompt replaces it, then the box takes focus with the cursor at the end. */
export function usePrefilledText(prefill: Prefill | null, focusOnMount: boolean) {
  const [text, setText] = useState(prefill?.text ?? '');
  const [appliedId, setAppliedId] = useState(prefill?.id);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  // React's derived-state pattern: adopt a new prompt during render rather than in an effect.
  if (prefill && prefill.id !== appliedId) {
    setAppliedId(prefill.id);
    setText(prefill.text);
  }

  useEffect(() => {
    if (!focusOnMount && !prefill) return;
    // After the prompt library drawer has closed, so its focus restore does not win.
    const id = window.setTimeout(() => {
      const input = inputRef.current;
      input?.focus();
      input?.setSelectionRange(input.value.length, input.value.length);
    }, 50);
    return () => { window.clearTimeout(id); };
  }, [focusOnMount, prefill]);

  return { text, setText, inputRef };
}
